var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_1281)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.104 44.2659C30.224 44.1599 22.062 43.0319 13.514 34.4859C4.968 25.9379 3.842 17.7779 3.734 14.8959C3.574 10.5039 6.938 6.23794 10.824 4.57194C11.292 4.36988 11.8044 4.29294 12.3111 4.34869C12.8177 4.40444 13.3012 4.59096 13.714 4.88994C16.914 7.22194 19.122 10.7499 21.018 13.5239C21.4352 14.1334 21.6135 14.875 21.5191 15.6075C21.4247 16.34 21.0641 17.0122 20.506 17.4959L16.604 20.3939C16.4155 20.5301 16.2828 20.73 16.2306 20.9566C16.1783 21.1832 16.2101 21.421 16.32 21.6259C17.204 23.2319 18.776 25.6239 20.576 27.4239C22.378 29.2239 24.882 30.8999 26.6 31.8839C26.8154 32.0049 27.069 32.0387 27.3085 31.9784C27.5481 31.9181 27.7554 31.7684 27.888 31.5599L30.428 27.6939C30.895 27.0736 31.5839 26.6581 32.3504 26.5343C33.1169 26.4105 33.9015 26.5881 34.54 27.0299C37.354 28.9779 40.638 31.1479 43.042 34.2259C43.3653 34.6418 43.5709 35.1368 43.6374 35.6592C43.7039 36.1817 43.6288 36.7124 43.42 37.1959C41.746 41.1019 37.51 44.4279 33.104 44.2659Z",
    fill: "#181933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_1281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f2939eb9580f876e68f4570324cb9be9.svg";
export { ForwardRef as ReactComponent };